/** Shared elevation for floating toolbar surfaces. */
export const TOOLBAR_SURFACE_SHADOW_CLASS =
  'shadow-[0_0_10px_0_rgba(0,0,0,0.2)]';

/**
 * Elevation for dropdown menus. The offset is half the blur radius so the
 * shadow stops at the menu's leading edge instead of bleeding back over the
 * toolbar the menu hangs from.
 */
export const dropdownSurfaceShadowClass = (opensUpward: boolean): string =>
  opensUpward
    ? 'shadow-[0_-5px_10px_0_rgba(0,0,0,0.2)]'
    : 'shadow-[0_5px_10px_0_rgba(0,0,0,0.2)]';
